import { css } from '@emotion/react';

export const content = css({
  width: 1152,
  height: 952,
  padding: '64px'
});

export const title = css({
  marginTop: 80,
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px'
});
